export default {
    formName: {
        fullName: 'Full Name',
        icNo: 'I/C No',
        gender: 'Gender',
        dob: 'D.O.B',
        phoneNum: 'Phone Number',
        emailAddress: 'Email Address',
        nationality: "Nationality",
        maritalStatus: 'Marital Status',
        race: 'Race',
        religion: 'Religion',
        otherReligion: 'Other Religion',
        vegetarian: 'Vegetarian',
        homeAddress: 'Home Address',
        'education[0].year': 'Education Year',
        'education[0].school': 'School',
        'education[0].qualification': 'Qualification',
        'education[0].grade': 'Grade',
        applyingPosition: 'Applying Position',
        workingExperience: 'Working Experience',
        referral: 'Referral',
        readyToJoinOn: 'Ready To Join On',
        currentSalary: 'Current Salary',
        expectedSalary: 'Expected Salary  ',
        linkedInUrl: 'LinkedIn URL',
        portfolioUrl: 'Portfolio URL ',
        portfolioUrl2: 'Portfolio URL(2)',
        'question[0].answer': 'Question 1',
        'question[1].answer': 'Question 2',
        'experience[0].gameTitle': 'Game Title',
        'experience[0].platform': 'Game Platform',
        englishSpeaking: 'English Speaking',
        englishWriting: 'English Writing',
        englishReading: 'English Reading',
        chineseSpeaking: 'Chinese Speaking',
        chineseWriting: 'Chinese Writing',
        chineseReading: 'Chinese Reading',
        malaySpeaking: 'Malay Speaking',
        malayWriting: 'Malay Writing',
        malayReading: 'Malay Reading',
        strength: 'Strength',
        weakness: 'Weakness',
        achievement: 'Achievement',
        expectation: 'Expectation',
        'questionList[0].value': 'Question 1 ',
        'questionList[1].value': 'Question 2 ',
        'questionList[2].value': 'Question 3 ',
        'questionList[3].value': 'Question 4 ',
        'questionList[4].value': 'Question 5 ',
        'questionList[5].value': 'Question 6 ',
        resumeFiles: 'Upload Resume',
    },
    allFormData: {
        //step1
        personalDetails: {
            fullName: '',
            icNo: '',
            gender: '',
            dob: '',
            phoneNum: '',
            emailAddress: '',
            nationality: '',
            maritalStatus: '',
            race: '',
            otherRace: '',
            religion: '',
            otherReligion: '',
            vegetarian: '',
            homeAddress: '',
            education: [
                {
                    year: '',
                    school: '',
                    qualification: '',
                    grade: ''
                },
                {
                    year: '',
                    school: '',
                    qualification: '',
                    grade: ''
                },
                {
                    year: '',
                    school: '',
                    qualification: '',
                    grade: ''
                }
            ]
        },
        //step2
        jobApplication: {
            applyingPosition: '',
            applyingPositionValue: '',
            workingExperience: '',
            referral: '',
            readyToJoinOn: '',
            currentSalary: '',
            expectedSalary: '',
            linkedInUrl: '',
            portfolioUrl: '',
            portfolioUrl2: '',
            question: [
                { title: 'Are you willing to take the pre-employment test to proceed further', answer: '' },
                { title: 'Would you be willing to participate in a phone or Zoom interview?', answer: '' }
            ],
            workDetail: [
                {
                    jobTitle: '',
                    durationRange: '',
                    monthlySalary: '',
                    resignationReason: '',
                    companyName: '',
                    contactNo: '',
                    emailAddress: ''
                }
            ]
        },
        //step3
        describeYourself: {
            experience: [
                {
                    gameTitle: '',
                    platform: '',
                },
                {
                    gameTitle: '',
                    platform: '',
                },
                {
                    gameTitle: '',
                    platform: '',
                }
            ],
            englishSpeaking: '',
            englishWriting: '',
            englishReading: '',

            chineseSpeaking: '',
            chineseWriting: '',
            chineseReading: '',

            malaySpeaking: '',
            malayWriting: '',
            malayReading: '',

            strength: '',
            weakness: '',
            achievement: '',
            expectation: ''
        },
        //step4
        questionnaire: {
            questionList: [
                {
                    title: 'Have you been or are you suffering from any physical impairment, heart attack, illness or disease?', value: '', reason: ''
                },
                { title: 'Have you ever been discharged or dismissed from the service of your previous employer?', value: '', reason: '' },
                { title: 'Have you ever been convicted in Court of Law in any country?', value: '', reason: '' },
                {
                    title: 'Have you ever been detained by the police of any government?',
                    value: '', reason: ''
                },
                { title: 'Are you a smoker?', value: '' },
                { title: 'Have you had a major surgery before?', value: '', reason: '' }
            ],
            imgName: 'Choose file',
            resumeName: 'Choose file',
            portfolioName: 'Choose file',
            additionalName: 'Choose file',
            imgFiles: '',
            resumeFiles: '',
            portfolioFiles: '',
            additionalFiles: ''
        },
        //step5
        agreement: {
            accept: false
        }
    },

    resetFormData() {
        let clearForm = {
            //step1
            personalDetails: {
                fullName: '',
                icNo: '',
                gender: '',
                dob: '',
                phoneNum: '',
                emailAddress: '',
                nationality: '',
                maritalStatus: '',
                race: '',
                otherRace: '',
                religion: '',
                otherReligion: '',
                vegetarian: '',
                homeAddress: '',
                education: [
                    {
                        year: '',
                        school: '',
                        qualification: '',
                        grade: ''
                    },
                    {
                        year: '',
                        school: '',
                        qualification: '',
                        grade: ''
                    },
                    {
                        year: '',
                        school: '',
                        qualification: '',
                        grade: ''
                    }
                ]
            },
            //step2
            jobApplication: {
                applyingPosition: '',
                applyingPositionValue: '',
                workingExperience: '',
                referral: '',
                readyToJoinOn: '',
                currentSalary: '',
                expectedSalary: '',
                linkedInUrl: '',
                portfolioUrl: '',
                portfolioUrl2: '',
                question: [
                    { title: 'Are you willing to take the pre-employment test to proceed further', answer: '' },
                    { title: 'Would you be willing to participate in a phone or Zoom interview?', answer: '' }
                ],
                workDetail: [
                    {
                        jobTitle: '',
                        durationRange: '',
                        monthlySalary: '',
                        resignationReason: '',
                        companyName: '',
                        contactNo: '',
                        emailAddress: ''
                    }
                ]
            },
            //step3
            describeYourself: {
                experience: [
                    {
                        gameTitle: '',
                        platform: '',
                    },
                    {
                        gameTitle: '',
                        platform: '',
                    },
                    {
                        gameTitle: '',
                        platform: '',
                    }
                ],
                englishSpeaking: '',
                englishWriting: '',
                englishReading: '',

                chineseSpeaking: '',
                chineseWriting: '',
                chineseReading: '',

                malaySpeaking: '',
                malayWriting: '',
                malayReading: '',

                strength: '',
                weakness: '',
                achievement: '',
                expectation: ''
            },
            //step4
            questionnaire: {
                questionList: [
                    {
                        title: 'Have you been or are you suffering from any physical impairment, heart attack, illness or disease?', value: '', reason: ''
                    },
                    { title: 'Have you ever been discharged or dismissed from the service of your previous employer?', value: '', reason: '' },
                    { title: 'Have you ever been convicted in Court of Law in any country?', value: '', reason: '' },
                    {
                        title: 'Have you ever been detained by the police of any government?',
                        value: '', reason: ''
                    },
                    { title: 'Are you a smoker?', value: '' },
                    { title: 'Have you had a major surgery before?', value: '', reason: '' }
                ],
                imgName: 'Choose file',
                resumeName: 'Choose file',
                portfolioName: 'Choose file',
                additionalName: 'Choose file',
                imgFiles: '',
                resumeFiles: '',
                portfolioFiles: '',
                additionalFiles: ''
            },
            //step5
            agreement: {
                accept: false
            }
        }
        this.allFormData = clearForm
    },
    // 属性写这里，可以全局使用，且响应
    routerChange() { }
}


